import { type ReactElement } from "react"
import getYourFans from "~/images/landing/get-your-fans.png"
import getYourFans2x from "~/images/landing/get-your-fans@2x.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

export function MobileGetYourFansImage(): ReactElement {
  return (
    <div className="block md:hidden">
      <div className="mt-[-12%] md:mt-0">
        <ResponsiveImage
          sources={[
            { media: BREAKPOINTS.mobile, src: getYourFans },
            { media: BREAKPOINTS.tabletUp, src: getYourFans2x },
          ]}
          fallbackSrc={getYourFans}
          alt="Get your fans in the group chat"
          className="max-w-[380px] max-xs:max-w-[330px] max-2xs:max-w-[300px]"
        />
      </div>
    </div>
  )
}
